import { ArticleClient } from 'api/clients/ArticleClient'
import { MessageVariant } from 'common/ToastMessage/Root'
import { FeedbackToast } from 'components/FeedbackToast/FeedbackToast'

export interface Props {
  generationId: number
  variant?: MessageVariant
  onClose?: () => void
  theme?: 'dark' | 'light'
}

export const RateGenerationToast = ({ generationId, theme = 'light', variant = 'rating', onClose }: Props) => {
  const handleRate = (rate: 'upvote' | 'downvote') => {
    ArticleClient.rateGeneration(generationId, rate)
    setTimeout(() => onClose?.(), 0)
  }

  return <FeedbackToast onRate={handleRate} onClose={onClose || (() => {})} theme={theme} variant={variant} />
}
